import { useCallback } from 'react';
import { ICustomFieldDataDataModel } from '../../../../data-models/custom-field-data.data-model';
import {
  bulkUpdateCustomFieldData,
  deleteCustomFieldData,
  getCustomFieldDataHistory,
  IUpdateCustomFieldDataPayload,
} from '../../../../services/queries/MaggieCustomFieldQueries';
import { getErrorMessage } from '../../../../services/queryHelpers';
import { useToastMessageState } from '../../../ToastMessage/ToastMessageProvider';

export function useUpdateTimeSeriesData() {
  const { pushErrorToast } = useToastMessageState();

  return useCallback(
    async (fieldData: IUpdateCustomFieldDataPayload[]) => {
      try {
        await bulkUpdateCustomFieldData(fieldData);
        const updatedFieldData = await getCustomFieldDataHistory({
          entityId: fieldData[0].entityId,
          customFieldId: fieldData[0].customFieldId,
        });
        return updatedFieldData;
      } catch (error) {
        console.error(error);
        pushErrorToast({ message: getErrorMessage(error, 'Failed to update time series data') });
      }
    },
    [pushErrorToast]
  );
}

export function useDeleteCustomFieldDataItem() {
  const { pushErrorToast } = useToastMessageState();

  return useCallback(
    async (fieldData: ICustomFieldDataDataModel) => {
      try {
        await deleteCustomFieldData(fieldData.id);
        const updatedFieldData = await getCustomFieldDataHistory({
          entityId: fieldData.entityId,
          customFieldId: fieldData.customFieldId,
        });
        return updatedFieldData;
      } catch (error) {
        console.error(error);
        pushErrorToast({ message: getErrorMessage(error, 'Failed to delete data from history') });
      }
    },
    [pushErrorToast]
  );
}
